module.exports = __webpack_public_path__ + "img/4acd5ad1b02814e31e8e3f3d51acd584.png";